import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Principal from './Componentes/Principal/Principal';
import Header from './Componentes/Header/Header';
import AboutUsp from './Componentes/AboutUs/Aboutus';
import Proyect from './Componentes/Proyect/Proyect';    
import Footer from './Componentes/Footer/Footer';
import Contactos from './Componentes/Contactos/Contactos';
import Scroll from './Componentes/Scroll/Scroll';
import Servicios from './Componentes/Servicios/Servicios';
import FormularioContacto from './Componentes/FormConsulta/FormConsulta';
import PantallaCarga from './Componentes/Preload/Preload';
import PlataformaEducativa from "./Componentes/PlataformaEducativa/PlataformaEducativa/PlataformaEducativa";
import Comunicacion from "./Componentes/PlataformaEducativa/PlataformaEducativa/Comunicacion.js"
import GestionAdministrativa from "./Componentes/PlataformaEducativa/PlataformaEducativa/gestionadministrativa.js"
import Pedagogia from "./Componentes/PlataformaEducativa/PlataformaEducativa/Pedagogia.js"

function App() {
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    // Simula la carga total del sitio (podés ajustarlo según tu caso)
    window.addEventListener("load", () => {
      setCargando(false);
    });

    // Por seguridad, si "load" no se dispara, ocultar después de 5 segundos
    const tiempoLimite = setTimeout(() => setCargando(false), 3000);

    return () => clearTimeout(tiempoLimite);
  }, []);

  if (cargando) {
    return <PantallaCarga />;
  }

  return (
    <BrowserRouter>
      <Scroll/>
      {/* <Header/> */}
      <Routes>
        <Route exact path="/" element={<Principal/>} />
        <Route path="/AboutUs" element={<AboutUsp/>} />
        <Route path="/Proyect" element={<Proyect/>} />
        <Route path="/Servicios" element={<Servicios/>} />
        <Route path="/Contactos" element={<Contactos/>} />
        <Route path="/form" element={<FormularioContacto/>} />
        <Route path="/PlataformaEducativa" element={<PlataformaEducativa/>} />
         <Route path="/Comunicacion" element={<Comunicacion/>} />
         <Route path="/gestionadministrativa" element={<GestionAdministrativa/>}/>
         <Route path="/Pedagogia" element={<Pedagogia/>}/>
      </Routes>
      {/* <Footer/> */}
    </BrowserRouter>
  );
}

export default App;
